import { CompletePage } from "apps/oneOnboarding/complete/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(CompletePage, "CompletePage");
